import { CONSTRUCTION_TYPE } from '@/constants/accessor/api/emergencyInspectionResult/assessmentInfo/constructionType'
import type { ConstructionTypeType } from '@/types/ui/inspection/constructionTypeTypes'

const WOOD = {
  surrounding: '➀',
  differentialSettlement: '➁',
  basics: '➂',
  firstFloorSlope: '➃',
  wall: '➄',
  corrosionOrTermite: '➅'
}

const STEEL = {
  surrounding: '➀',
  settlementSlopeSteel: '➁',
  slope: '➂',
  mostDamagedFloor: '➃～➇',
  buckling: '➃',
  brace: '➄',
  pillarBeamJoint: '➅',
  pillarBase: '➆',
  corrosion: '➇'
}

const RC = {
  partsDamageGte3: '➀',
  surrounding: '➁',
  groundDestructionSettlement: '➂',
  settlementSlope: '➃',
  mostDamagedFloor: '➄➅',
  pillarDamage5: '➄',
  pillarDamage4: '➅'
}

const cardNumber = {
  [CONSTRUCTION_TYPE.WOOD]: WOOD,
  [CONSTRUCTION_TYPE.STEEL]: STEEL,
  [CONSTRUCTION_TYPE.RC]: RC
}

/**
 * 指定された建物構造タイプに対応するカードのナンバーを返却する
 *
 * @param selectedConstructionType 選択された構造タイプ
 * @returns 該当するカードのナンバー
 */
export const getNeighboringCardNumbers = (selectedConstructionType: ConstructionTypeType) => {
  const numbers = cardNumber[selectedConstructionType]

  if (!numbers) {
    console.error(`Invalid construction type: ${selectedConstructionType}`)
    return null
  }

  return numbers
}
